import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import EBookForm from '../components/EBookForm';
import ConstructionDashboardPromo from '../components/ConstructionDashboardPromo';
import Footer from '../components/Footer';
import PromptRibbon from '../components/Ribbon';

const Home = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
      <EBookForm />
      <ConstructionDashboardPromo />
      <Footer />
      <PromptRibbon />
    </>
  );
};

export default Home;
